import {
  BFF_ROUTES,
  CreditDecisionResponseSchema,
  type CreditCheckRequest,
  type CreditDecisionResponse,
} from '@rheora/enrollment-contract';

import { bffPost } from './bff-client';

/**
 * Typed fetcher for the E-SF05 credit check. Thin: POST the request, validate the
 * response against the shared contract schema, return. Pages never import this
 * directly — the `credit.queries` hook wraps it.
 *
 * ── SSN POSTURE ────────────────────────────────────────────────────────────
 * The request carries name/DOB/SSN; `bffPost` sends it credential-free over the
 * same-origin `/bff/*` proxy (the BFF forwards it to Accounts server-side). The
 * RESPONSE is decision-only — the contract schema has no SSN/DOB/score field, so
 * a drifted response carrying one fails `safeParse` here rather than reaching the
 * cache.
 */
export async function postCreditCheck(request: CreditCheckRequest): Promise<CreditDecisionResponse> {
  return bffPost(BFF_ROUTES.creditCheck, request, CreditDecisionResponseSchema);
}
